module.exports = __webpack_public_path__ + "img/about1.043e23d9.jpg";